export enum ESVGRole {
  APPLICATION = 'application',
  DOCUMENT = 'document',
  IMG = 'img',
}
